import React from 'react';
import DeviceSettingsCore from './deviceSettings/DeviceSettingsCore';

export { ThresholdInputs, RelayModeControl } from './deviceSettings/DeviceSettingsCore';

export default function DeviceSettingsModal({
  show,
  onClose,
  onSave,
  onSaveThresholds,
  canSaveThresholds,
  saving,
  controller,
  t,
  telegramEnabled,
  setTelegramEnabled,
  powerAlerts,
  setPowerAlerts,
  thresholdAlerts,
  setThresholdAlerts,
  trendAlerts,
  setTrendAlerts,
  thresholds,
  setThresholdField,
  waterConfig,
  setWaterConfigField,
  timeSyncPending,
  co2OffsetDraft,
  setCo2OffsetDraft,
  calibrationTargetPpm,
  setCalibrationTargetPpm,
  onForceCalibrate,
  pendingCalibration = false,
  calibrationStartedUi = false,
  calibrationCountdownText = '05:00',
  settingsStatus,
  settingsProgressText,
  deviceName,
  setDeviceName,
  relayStatuses = {},
  relayModes = {},
  onRelayCommand,
  relayPending = {},
  relayCommandStatus = null,
  onSaveDisplayName = null,
  nameSavePending = false,
  relayControlsDisabled = false,
  relayStale = false,
  canRestartController = false,
  onRestartController = null,
  restartPending = false,
  restartStatus = null,
  notificationDelivery = null,
  notificationActionPending = false,
  onEnableClimateAlerts = null,
}) {
  const thresholdSaveHandler = onSaveThresholds || onSave;
  if (!show) return null;

  return (
    <div className="modal d-block device-settings-modal" tabIndex="-1" role="dialog" onClick={onClose}>
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-content device-settings-modal__content">
          <div className="modal-header">
            <h5 className="modal-title">{t('settings')}</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body p-3">
            <DeviceSettingsCore
              onSaveThresholds={thresholdSaveHandler}
              canSaveThresholds={canSaveThresholds}
              saving={saving}
              controller={controller}
              t={t}
              telegramEnabled={telegramEnabled}
              setTelegramEnabled={setTelegramEnabled}
              powerAlerts={powerAlerts}
              setPowerAlerts={setPowerAlerts}
              thresholdAlerts={thresholdAlerts}
              setThresholdAlerts={setThresholdAlerts}
              trendAlerts={trendAlerts}
              setTrendAlerts={setTrendAlerts}
              thresholds={thresholds}
              setThresholdField={setThresholdField}
              waterConfig={waterConfig}
              setWaterConfigField={setWaterConfigField}
              timeSyncPending={timeSyncPending}
              co2OffsetDraft={co2OffsetDraft}
              setCo2OffsetDraft={setCo2OffsetDraft}
              calibrationTargetPpm={calibrationTargetPpm}
              setCalibrationTargetPpm={setCalibrationTargetPpm}
              onForceCalibrate={onForceCalibrate}
              pendingCalibration={pendingCalibration}
              calibrationStartedUi={calibrationStartedUi}
              calibrationCountdownText={calibrationCountdownText}
              settingsStatus={settingsStatus}
              settingsProgressText={settingsProgressText}
              deviceName={deviceName}
              setDeviceName={setDeviceName}
              relayStatuses={relayStatuses}
              relayModes={relayModes}
              onRelayCommand={onRelayCommand}
              relayPending={relayPending}
              relayCommandStatus={relayCommandStatus}
              onSaveDisplayName={onSaveDisplayName}
              nameSavePending={nameSavePending}
              relayControlsDisabled={relayControlsDisabled}
              relayStale={relayStale}
              canRestartController={canRestartController}
              onRestartController={onRestartController}
              restartPending={restartPending}
              restartStatus={restartStatus}
              notificationDelivery={notificationDelivery}
              notificationActionPending={notificationActionPending}
              onEnableClimateAlerts={onEnableClimateAlerts}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
